import { ModSettable } from "ixfx/modulation.js";
import { TimingSourceFactory } from '../types';
import { ModulationTimerFactory } from "./timer";
import * as Flow from "ixfx/flow.js";
import { interpolate } from "ixfx/numbers.js";
import { AnimationAtom, AnimationThing } from './types';

export const attributeAssign = (name: string, start: number, target: number, curve: (v: number) => number, el: SVGElement | HTMLElement): AnimationAtom => {
  const opts = { limits: `ignore` } as const;
  const tick = (progress: number) => {
    const absoluteValue = interpolate(progress, start, target, opts)
    el.setAttribute(name, absoluteValue.toString());
  }
  return {
    tick
  }
}

export const styleAssign = (name: string, start: number, target: number, curve: (v: number) => number, el: SVGElement | HTMLElement): AnimationAtom => {
  const opts = { limits: `ignore` } as const;
  const tick = (progress: number) => {
    const absoluteValue = interpolate(progress, start, target, opts);
    el.style.setProperty(name, absoluteValue.toString());
  }
  return { tick }
}

export const mergeAtoms = (atoms: AnimationAtom[]): AnimationAtom => {
  const tick = (v: number) => {
    for (let i = 0; i < atoms.length; i++) {
      atoms[ i ].tick(v);
    }
  }
  return { tick }
}